import { GATE_IN, GATE_OUT, PROCESS_TIME_FIELD, QUICK_FILL_EXCLUDED_FIELDS } from 'utils/constants';
import { FENIX_EXPORTED_TO_YMS_FIELD } from 'utils/fenixYms';

// Load state of a protocol for one location + gate direction. NOT_CONFIGURED is never stored: it is
// what the selectors answer for a transaction whose location has no protocol.
export const PROTOCOL_STATUS = Object.freeze({
    NOT_CONFIGURED: 'NOT_CONFIGURED',
    LOADING: 'LOADING',
    AVAILABLE: 'AVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    INVALID: 'INVALID',
});

// Matches the S3 objects' `Cache-Control: max-age=300`, so a replaced XML is live within about
// 5-10 minutes without an AIQ deployment.
export const PROTOCOL_CACHE_TTL_MS = 5 * 60 * 1000;

// The transaction's gate direction and the `<metadata><gate><direction>` the XML must declare.
export const PROTOCOL_DIRECTION_BY_GATE_DIRECTION = Object.freeze({
    [GATE_IN]: 'inbound',
    [GATE_OUT]: 'outbound',
});

// `<step type>` values the FE knows. Any other type is shown as an instruction.
export const PROTOCOL_STEP_TYPE = Object.freeze({
    FORM: 'form',
    INSTRUCTION: 'instruction',
    DECISION: 'decision',
});

// Icon per step type (Figma `16780:55141`); the panel maps each key to its icon component.
export const PROTOCOL_STEP_ICON_BY_TYPE = Object.freeze({
    [PROTOCOL_STEP_TYPE.FORM]: 'clipboard',
    [PROTOCOL_STEP_TYPE.INSTRUCTION]: 'idCard',
    [PROTOCOL_STEP_TYPE.DECISION]: 'barrier',
});

// Value suggested for the AIQ form fields the case's XML form leaves out (the `/` chip, Submit / Ctrl+Enter prefill).
export const PROTOCOL_SUGGESTION_VALUE = '/';

// Fields with their own fill logic, which a protocol `/` would break: Process Time (timer suggestion and
// its Driver rule), Exported to YMS (Fenix), Send to Bison (a control flag), and the fields Submit must
// leave for the Agent to pick (conditionals autofill).
export const PROTOCOL_SLASH_EXCLUDED_FIELDS = new Set([
    PROCESS_TIME_FIELD,
    FENIX_EXPORTED_TO_YMS_FIELD,
    'sendToBison',
    ...QUICK_FILL_EXCLUDED_FIELDS,
]);

// Announcement fields hold what a matched announcement copied in, never an Agent's input.
export const PROTOCOL_SLASH_EXCLUDED_FIELD_PREFIXES = Object.freeze(['announcement.']);

// The variable each `<case>` sets with `<set name="current_form">`, read by `<render formRef="${current_form}">`.
export const CURRENT_FORM_VARIABLE = 'current_form';
